/**
 * useAnnouncement: whether this user is shown an announcement, which the
 * backend decides (announcementService: its audience, and never dismissed),
 * and a way to close it for good. A dismissal that fails changes nothing:
 * the banner stays and the person is told (the slice logs the cause). The
 * become-a-vendor announcement and the listings-need-receipts notice both
 * close this way (Tyler, 2026-10-10: "dismiss forever").
 */
import type { AnnouncementKey } from '@gearghost/api-schemas/announcement'
import { useDismissAnnouncementMutation, useGetAnnouncementsQuery } from '@/redux/api/announcementApi'
import { toastError } from '@/utils/toast.jsx'

/** What the person is told when closing an announcement fails. */
export const ANNOUNCEMENT_DISMISS_FAILED = 'We could not dismiss that. Please try again.'

export const useAnnouncement = (key: AnnouncementKey) => {
  const { data } = useGetAnnouncementsQuery()
  const [dismissAnnouncement] = useDismissAnnouncementMutation()

  const shown = data === undefined ? false : data.announcements.some((announcement) => announcement.key === key)

  const dismiss = async () => {
    const result = await dismissAnnouncement({ key })
    if ('error' in result) toastError(ANNOUNCEMENT_DISMISS_FAILED)
  }

  return { shown, dismiss }
}
